import { gql } from '@apollo/client';
import React, { useState } from 'react';
import { SuccessMessageFragment } from '../../../types/__generated__';
import usePageQuery, { buildQuery } from '../../hooks/usePageQuery';
import useBasePageQuery from '../../hooks/useBasePageQuery';
import { useCharityAdmin } from '../../hooks/useCharityAdmin';
import { useIsMounted } from '../../hooks/useIsMounted';
import { Trans } from 'react-i18next';
import config from '../../client/config';
import Alert from '@justgiving/alert';
import SuccessMessageEditBar from './SuccessMessageEditBar';
import SuccessMessageModal from './SuccessMessageModal';

const FRAGMENT = buildQuery(
  gql`
    fragment SuccessMessage on Page {
      id
      targetWithCurrency {
        currencyCode
      }
    }
  `,
);

const SuccessMessage: React.FunctionComponent = () => {
  const result = usePageQuery<SuccessMessageFragment>(FRAGMENT);
  const basePageData = useBasePageQuery();
  const [successMessageModalOpen, setSuccessMessageModalOpen] = useState(false);
  const { isCharityAdmin } = useCharityAdmin();
  const isMounted = useIsMounted();

  const [showAlert, setShowAlert] = useState<boolean>(true);

  if (!basePageData.data?.page) {
    return null;
  }

  if (!isMounted) {
    return null;
  }

  const { title, legacyId } = basePageData.data.page;

  const campaignTitle = title;
  const charityGuid = legacyId;

  const editUrl = `${config.baseUri}/campaign/manage/edit/${charityGuid}`;
  const currencyCode = result?.data?.targetWithCurrency?.currencyCode;

  const showSuccessMessage =
    window.location.search.indexOf('success=true') > -1;

  if (showSuccessMessage && isCharityAdmin && showAlert) {
    return (
      <section data-qa="success-message">
        <Alert type="success" onClose={() => setShowAlert(false)}>
          <Trans i18nKey="campaign.successPublishMessage">
            Congratulations! Your Campaign is now live. You can{' '}
            <a className="pointer" href={editUrl}>
              edit your Campaign
            </a>{' '}
            at any time.
          </Trans>
        </Alert>
        <SuccessMessageEditBar
          title={campaignTitle}
          editUrl={editUrl}
          openModal={() => {
            setSuccessMessageModalOpen(true);
          }}
        />
        <SuccessMessageModal
          defaultCurrencyAmount={100}
          currencyCode={currencyCode}
          isModalOpen={successMessageModalOpen}
          onCloseModal={() => {
            setSuccessMessageModalOpen(false);
          }}
        />
      </section>
    );
  }

  return null;
};

export default SuccessMessage;
